import { UserRole } from '@/types';

export function isMasterAdmin(role: UserRole | undefined): boolean {
  return role === 'masterAdmin';
}
